<template>
  <div
    v-click-outside="closeDropdown"
    class="button-dropdown"
    :style="{ width }"
  >
    <button
      class="btn-primary"
      :class="{ 'btn-icon': icon }"
      @click="toggleDropdown"
    >
      <md-icon
        v-if="icon"
        :md-src="'/static/images/' + icon + '.svg'"
        class="icon-download"
      />

      <span>
        {{ internalSelectedOption }}
      </span>
    </button>
    <ul
      v-if="isOpen"
      class="button-dropdown__menu"
    >
      <li
        v-for="(option, index) in options"
        :key="`dropdown-option-${index}-${option}`"
        @click="selectOption(option)"
      >
        {{ option }}
      </li>
    </ul>
  </div>
</template>

<script>
import { clickOutside } from '@/utils/directives'

export default {
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    },
    clickOutside,
  },
  props: {
    initialOptions: {
      type: Array,
      required: true,
    },
    itMayChangeSelectedOption: {
      type: Boolean,
      default: true,
    },
    selectedOption: {
      type: String,
      default: 'Selecione uma opção',
    },
    width: {
      type: String,
      default: '100%',
    },
    icon: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
      options: [],
      internalSelectedOption: this.selectedOption,
    }
  },
  watch: {
    initialOptions: {
      handler(newOptions) {
        this.options = newOptions || []
      },
      immediate: true,
    },
    selectedOption: {
      handler(newValue) {
        this.internalSelectedOption = newValue
      },
      immediate: true,
    },
  },
  mounted() {
    this.options = this.initialOptions
  },
  methods: {
    closeDropdown() {
      this.isOpen = false
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    selectOption(option) {
      if (this.itMayChangeSelectedOption) {
        this.internalSelectedOption = option
      }

      this.isOpen = false
      this.$emit('option-selected', option)
    },
  },
}
</script>

<style lang="scss">
.button-dropdown {
  position: relative;
  display: inline-block;

  &__menu {
    position: absolute;
    background-color: #fff;
    border: 1px solid #ced4da;
    padding: 5px 0;
    margin-top: 5px;
    list-style: none;
    width: 100%;
    z-index: 1040;

    li {
      padding: 10px 15px;
      cursor: pointer;

      &:hover {
        background-color: #f8f9fa;
      }
    }
  }

  button {
    width: 100%;
    font-weight: 500;
    text-transform: uppercase;
    font-family: 'Exo 2', sans-serif !important;
    padding: 10px 15px;
    cursor: pointer;
    color: #fff;

    span {
      font-weight: 600;
    }

    &.btn-icon {
      display: flex;
      justify-content: center;
      align-items: center;

      .md-icon {
        width: 18px;
        min-width: 18px;
        margin: 0;
        margin-right: 8px;
      }
    }
  }
}
</style>
